import instanciaAxios from './InterceptorAxios';

const servicioCancelacion = {
    cancelarCfdi(cancelacionDto) {
		return instanciaAxios.post('/cancelacion/cancelarCfdis.json',cancelacionDto);
  }
}

export default servicioCancelacion;